export const SEARCH = 'search/SEARCH';
export const SEARCH_QUERY_SEND = 'search/QUERY_SEND';
export const SEARCH_CLEAR_RESULTS = 'search/CLEAR_RESULTS';
export const MIN_QUERY_LENGTH = 2;
